const styles = theme => ({
  wrapFlexCenter: {
    margin: '24px 22px 24px 0',
  },
  textContentCenter: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
  deleteButtonStyle: {
    marginTop: 7,
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.text.primary,
      cursor: 'pointer',
    },
  },
  gridMargin: {
    marginTop: 10,
    marginBottom: 10,
  },
  textNote: {
    color: theme.palette.text.secondary,
  },
  dialogContent: {
    padding: 24,
  },
  dialogText: {
    margin: '0 0 8px',
    fontSize: '14px',
    color: theme.palette.text.secondary,
    lineHeight: '28px',
  },
  dialogImage: {
    width: '50%',
  },
  imageCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
  dropzone: {
    width: '100%',
    margin: '15px 0',
    backgroundColor: theme.palette.background.paper,
  },
  infoText: {
    color: theme.palette.text.secondary,
    lineHeight: '19px',
    fontSize: '14px',
  },
  addColumnText: {
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary,
    '&:hover': {
      cursor: 'pointer',
      color: `${theme.palette.text.primary} !important`,
    },
  },
  styledAddIcon: {
    marginRight: 2,
  },
  addColumnButtonWrapper: {
    marginBottom: 16,
  },
  addColumnButton: {
    // Add any button-specific tweaks here if needed
  },
});
export default styles;
